import { type AgeStatsItem } from "../models";

export const isEmptyStateAgeStats = (stats: AgeStatsItem<number>[]): boolean => {
    let isEmpty = true;

    for (const stat of stats) {
        if (stat.men > 0 || stat.women > 0) {
            isEmpty = false;
            break;
        }
    }
    return isEmpty;
};
